import React from 'react';
import { VSColumn } from './VSColumn';
import { classNames } from '../../utils/style';
import {
  fontBody,
  fontHeading2,
  fontMegaBody,
} from '../../styles/typographyNew';

export const VS = ({ title, subtitle, positifColumn, negativeColumn }: any) => {
  return (
    <div className={classNames('VS', 'text-[#364A61]')}>
      <div className={classNames('VS__head', 'mb-[60px] text-center')}>
        {title && (
          <div
            className={classNames(
              'VS__title',
              fontHeading2,
              'text-[#042040]',
              'max-w-[748px] m-auto mb-24',
            )}
          >
            {title}
          </div>
        )}
        {subtitle && (
          <div
            className={classNames(
              'VS__subtitle',
              fontMegaBody,
              'max-w-[680px] m-auto',
            )}
          >
            {subtitle}
          </div>
        )}
      </div>
      <div
        className={classNames(
          'VS__content',
          fontBody,
          'text-left',
          'flex flex-col gap-24',
          'lg:flex-row lg:gap-20 ',
        )}
      >
        {positifColumn && (
          <VSColumn
            className={classNames(
              'bg-[#EBF4FF] shadow-boxBlueLight flex-1',
              'border-[#B4D5FA] border-[3px]',
            )}
            {...positifColumn}
          />
        )}
        {negativeColumn && (
          <VSColumn
            className={classNames(
              'bg-[#F7F9FC] flex-1',
              'border-[#F7F9FC] border-[3px]',
            )}
            {...negativeColumn}
          />
        )}
      </div>
    </div>
  );
};
